import { useTranslation } from 'react-i18next';
import { DetailsListView, EntityGridListProps } from '../../../Common/DetailsList/DetailListView';

import { DateTime } from 'luxon';
import { Icon } from '@fluentui/react';

export const ReportHoursSettlementGridList = (props: EntityGridListProps) => {
  const { t } = useTranslation();

  const formatActivo = (item: any) => {
    if (item.sexpasinc_activo === '1') {
      return <Icon iconName="CheckMark" className="color-success" />;
    } else {
      return <Icon iconName="Cancel" className="color-error" />;
    }
  };

  const formatDateString = (dateString: string) => { // YYYYMM
    return <span>{DateTime.fromFormat(dateString, 'yyyyMM').toFormat('MM/yyyy')}</span>;
  };

  const agrupadoresCorporacionLiquidadora = [
    {
      agrcorliq_id: 1,
      agrcorliq_nombre: 'AJEFILMS SERVICIOS',
      agrcorliq_tipo: 'AJE_FILMS_SERVICES',
    },
    {
      agrcorliq_id: 2,
      agrcorliq_nombre: 'AJEFILMS PROYECTOS',
      agrcorliq_tipo: 'AJE_FILMS_PROJECTS',
    },
    {
      agrcorliq_id: 3,
      agrcorliq_nombre: 'ASESORIAS PERU',
      agrcorliq_tipo: 'ASESORIAS_PE',
    },
    {
      agrcorliq_id: 4,
      agrcorliq_nombre: 'ASESORIAS ESPAÑA',
      agrcorliq_tipo: 'ASESORIAS_ES',
    },
  ];

  const columns = [
    {
      fieldName: 'sexpasinc_id',
      name: t('ID'),
      maxWidth: 60,
      minWidth: 60,
    },
    {
      fieldName: 'sexpasinc_periodo',
      name: t('Período'),
      _onRender: (item: any) => formatDateString(item.sexpasinc_periodo),
      maxWidth: 50,
      minWidth: 50,
    },
    {
      fieldName: 'sexpasinc_fecha_ejecucion',
      name: t('Fecha de carga'),
      maxWidth: 100,
      minWidth: 100,
    },
    {
      fieldName: 'colaborador',
      name: t('Generada por'),
      minWidth: 350,
      maxWidth: 350,
    },
    {
      fieldName: 'sexpasinc_agrcorliq_tipo',
      name: t('Tipo de liquidación'),
      _onRender: (item: any) => {
        const agrupador = agrupadoresCorporacionLiquidadora.find((a) => a.agrcorliq_tipo === item.sexpasinc_agrcorliq_tipo);
        return agrupador ? agrupador.agrcorliq_nombre : 'NA';
      },
      maxWidth: 100,
      minWidth: 100,
    },
    {
      fieldName: 'sexpasinc_estado',
      name: t('Estado'),
      maxWidth: 100,
      minWidth: 100,
    },
    {
      fieldName: 'sexpasinc_activo',
      name: t('Activa'),
      _onRender: (item: any) => formatActivo(item),
      maxWidth: 20,
      minWidth: 20,
    },
  ];
  return (
    <>
      <DetailsListView
        changeBlockUI={props.changeBlockUI}
        keyList={props.keyList}
        onClickCardMode={() => props.onClickCardMode()}
        onClickGridMode={() => props.onClickGridMode()}
        mode={props.mode}
        title={t('Lista de solicitudes')}
        cols={columns}
        isGridList={true}
        courier={props.courier}
        listFilters={[]}
        quickFilters={props.quickFilters}
        onItemClick={props.onItemClick}
        baseUrl={props.baseUrl}
      ></DetailsListView>
    </>
  );
};
